import { render, staticRenderFns } from "./_MediaGroupArchiveWrapper.vue?vue&type=template&id=1bf9a16a&scoped=true&"
import script from "./_MediaGroupArchiveWrapper.vue?vue&type=script&lang=js&"
export * from "./_MediaGroupArchiveWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf9a16a",
  null
  
)

export default component.exports